import { useState, useEffect } from "react";
import { Link, useLocation } from "wouter";
import { SITE_TITLE, SITE_DESCRIPTION } from "@/lib/constants";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [location] = useLocation();
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  // Check if the current route is active
  const isActive = (path: string) => {
    return location === path;
  };

  return (
    <header className="bg-[#4A1D6E] text-white py-4 shadow-md">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
        <div className="text-center md:text-left mb-4 md:mb-0">
          <Link href="/">
            <a className="block">
              <h1 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold">{SITE_TITLE}</h1>
              <p className="text-sm md:text-base text-[#D4AF37]">{SITE_DESCRIPTION}</p>
            </a>
          </Link>
        </div>
        
        <nav className="hidden md:block">
          <ul className="flex space-x-8">
            <li>
              <Link href="/">
                <a className={`nav-link text-white hover:text-[#D4AF37] transition duration-300 ${isActive('/') ? 'active-nav' : ''}`}>Home</a>
              </Link>
            </li>
            <li className="relative" 
                onMouseEnter={() => setShowAboutDropdown(true)} 
                onMouseLeave={() => setShowAboutDropdown(false)}>
              <Link href="/about">
                <a className={`nav-link text-white hover:text-[#D4AF37] transition duration-300 ${isActive('/about') ? 'active-nav' : ''}`}>About</a>
              </Link>
              {showAboutDropdown && (
                <div className="absolute mt-2 bg-[#4A1D6E] shadow-lg rounded-md py-2 px-4 z-10 w-48">
                  <a href="/about#about-band" className="block py-2 text-white hover:text-[#D4AF37]">
                    About the Band
                  </a>
                  <a href="/about#musical-director" className="block py-2 text-white hover:text-[#D4AF37]">
                    Musical Director
                  </a>
                </div>
              )}
            </li>
            <li>
              <Link href="/events">
                <a className={`nav-link text-white hover:text-[#D4AF37] transition duration-300 ${isActive('/events') ? 'active-nav' : ''}`}>Events</a>
              </Link>
            </li>
            <li>
              <Link href="/gallery">
                <a className={`nav-link text-white hover:text-[#D4AF37] transition duration-300 ${isActive('/gallery') ? 'active-nav' : ''}`}>Gallery</a>
              </Link>
            </li>
            <li>
              <Link href="/join">
                <a className={`nav-link text-white hover:text-[#D4AF37] transition duration-300 ${isActive('/join') ? 'active-nav' : ''}`}>Join the Band</a>
              </Link>
            </li>
          </ul>
        </nav>
        
        <div className="md:hidden">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="text-white p-2"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {/* Mobile navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-[#4A1D6E] w-full">
          <div className="container mx-auto px-4 py-2">
            <ul className="space-y-4">
              <li>
                <Link href="/">
                  <a className="block text-white hover:text-[#D4AF37] py-2">Home</a>
                </Link>
              </li>
              <li>
                <Link href="/about">
                  <a className="block text-white hover:text-[#D4AF37] py-2">About</a>
                </Link>
              </li>
              <li className="pl-4">
                <a href="/about#about-band" className="block text-white hover:text-[#D4AF37] py-2">
                  - About the Band
                </a>
              </li>
              <li className="pl-4">
                <a href="/about#musical-director" className="block text-white hover:text-[#D4AF37] py-2">
                  - Musical Director
                </a>
              </li>
              <li>
                <Link href="/events">
                  <a className="block text-white hover:text-[#D4AF37] py-2">Events</a>
                </Link>
              </li>
              <li>
                <Link href="/gallery">
                  <a className="block text-white hover:text-[#D4AF37] py-2">Gallery</a>
                </Link>
              </li>
              <li>
                <Link href="/join">
                  <a className="block text-white hover:text-[#D4AF37] py-2">Join the Band</a>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
}
